<div class="container" *ngIf="isSuperAdmin">
  <div class="row head">
    <div class="col-12">
      <span class="title" i18n="parameters|@@exportkpi">Export KPI</span>
    </div>
  </div>
  <div class="row generalrows">
    <div class="col-3 center">
      <span class="span-txt" i18n="parameters|@@date">Date : </span>
    </div>
    <div class="col-9">
      <div id="datepicker-wrapper">

        <input autocomplete="off" type="text" matInput ngxDaterangepickerMd
          [locale]="{applyLabel: 'ok', format: 'DD-MM-YYYY'}" startKey="start" endKey="end" [(ngModel)]="date"
          name="daterange" id="daterange" [ranges]="ranges" alwaysShowCalendars="true"
          (ngModelChange)="updateSearchDate($event)" placeholder="Aujourd'hui..."
          i18n-placeholder="finder|@@date_today" />

        <ng-container *ngIf="isDate; else elseTemplate">
          <svg class="calendar-icon" width="16px" height="16px" viewBox="0 0 16 16" (click)="erasedate()" version="1.1"
            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->
            <title>clear</title>
            <desc>Created with Sketch.</desc>
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="UI-Rapport-Tablet-Scroll" transform="translate(-747.000000, -347.000000)" fill="#E3E3E3"
                fill-rule="nonzero">
                <g id="Content" transform="translate(12.000000, -101.000000)">
                  <g id="01" transform="translate(20.000000, 80.000000)">
                    <g id="Section" transform="translate(0.000000, 326.000000)">
                      <g id="Group-9" transform="translate(1.000000, 35.000000)">
                        <path
                          d="M722,7 C717.6,7 714,10.6 714,15 C714,19.4 717.6,23 722,23 C726.4,23 730,19.4 730,15 C730,10.6 726.4,7 722,7 Z M725.5,17.1 L724.1,18.5 L722,16.4 L719.9,18.5 L718.5,17.1 L720.6,15 L718.5,12.9 L719.9,11.5 L722,13.6 L724.1,11.5 L725.5,12.9 L723.4,15 L725.5,17.1 Z"
                          id="Shape"></path>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </ng-container>
        <ng-template #elseTemplate>
          <svg class="calendar-icon" width="16px" height="16px" viewBox="0 0 16 16" version="1.1"
            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->
            <title>calendar-date-2</title>
            <desc>Created with Sketch.</desc>
            <g id="Page-1" stroke="none" stroke-width="1">
              <g id="UI-Dashboard-+-Calendar-02" transform="translate(-842.000000, -169.000000)">
                <g id="Calendar" transform="translate(625.000000, 155.000000)">
                  <g id="calendar-date-2" transform="translate(217.000000, 14.000000)">
                    <path
                      d="M15,2 L13,2 L13,0 L10,0 L10,2 L6,2 L6,0 L3,0 L3,2 L1,2 C0.448,2 0,2.448 0,3 L0,15 C0,15.552 0.448,16 1,16 L15,16 C15.552,16 16,15.552 16,15 L16,3 C16,2.448 15.552,2 15,2 Z M14,14 L2,14 L2,5 L14,5 L14,14 Z"
                      id="Shape"></path>
                    <rect id="Rectangle" x="4" y="7" width="2" height="2"></rect>
                    <rect id="Rectangle" x="7" y="7" width="2" height="2"></rect>
                    <rect id="Rectangle" x="4" y="10" width="2" height="2"></rect>
                    <rect id="Rectangle" x="7" y="10" width="2" height="2"></rect>
                    <rect id="Rectangle" x="10" y="7" width="2" height="2"></rect>
                    <rect id="Rectangle" x="10" y="10" width="2" height="2"></rect>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </ng-template>

      </div>
    </div>
  </div>
  <div class="row generalrows">
    <div class="col-3 center">
      <span class="span-txt">Scanner : </span>
    </div>
    <div class="col-9" *ngIf="!deviceLoader">
      <ng-select [items]="devicesSelector" [bindLabel]="'name'" [bindValue]="'id'" [(ngModel)]="deviceId"
        [virtualScroll]='true' notFoundText="---" [clearable]='true' [searchable]='true'
        placeholder='Liste des Scanners' i18n-placeholder="exportKpi|@@ScannerList">
      </ng-select>
    </div>
  </div>
  <div class="row generalrows">
    <div class="col-10 center">
    </div>
    <div class="col-2">
      <button class="btn btn-lg primary" (click)="export()" i18n="exportKpi|@@export">EXPORT</button>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/element/export-kpi/export-kpi.component.html